import Vue from "vue";
import VueCarousel from "vue-carousel";
import "vue-awesome/icons";
import Icon from "vue-awesome/components/Icon";
// import VueAnalytics from 'vue-analytics';
// import * as VueGoogleMaps from 'vue2-google-maps';
// import VueI18n from 'vue-i18n';
// import VueScrollTo from 'vue-scrollto';
// import router from '../router';
import vMediaQuery from "v-media-query";
import axios from "axios";
import VueAxios from "vue-axios";
// import 'buefy/dist/buefy.css'; // remove me
// import Buefy from 'buefy';
// import VeeValidate from 'vee-validate';
// import { VueAuthenticate } from 'vue-authenticate';
import hero from "@/components/utils/hero";
import card from "@/components/utils/card";
import Thumb from "@/components/utils/Thumb";
import Loading from "@/components/utils/Loading";
import breadCrumb from "@/components/utils/breadcrumb";

Vue.component("hero", hero);
Vue.component("card", card);
Vue.component("Thumb", Thumb);
Vue.component("Loading", Loading);
Vue.component("breadCrumb", breadCrumb);

// Vue.use(VeeValidate);
// Vue.use(Buefy);
Vue.use(VueAxios, axios);
// Vue.use(VueGoogleMaps, {
//   load: {
//     key: 'AIzaSyBvWE_sIwKbWkiuJQOf8gSk9qzpO96fhfY',
//     libraries: 'places',
//   },
// });
Vue.use(vMediaQuery, {
  variables: {
    tablet: "770px",
    miniLaptop: "990px",
  },
});
// Vue.use(VueAnalytics, {
//   id: 'UA-XXX-X',
//   router,
// });
Vue.use(VueCarousel);
Vue.component("icon", Icon);
// Vue.use(VueI18n);
// Vue.use(VueScrollTo, {
//      container: "body",
//      duration: 800,
//      easing: "ease",
//      offset: -70,
//      cancelable: true,
//      onDone: false,
//      onCancel: false,
//      x: false,
//      y: true
//  });

Vue.mixin({
  data: function () {
    return {
      baseURL() {
        return "atd-cms.nbhood.com";
      },
    };
  },
});



// WEBPACK FOOTER //
// ./src/plugins/index.js